module.exports = __webpack_public_path__ + "c4450804b4ed02692c100c9efba49ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/28_PROP_BAK_06.png
// module id = 128
// module chunks = 0